import { render, staticRenderFns } from "./ModelYM.vue?vue&type=template&id=78ea2540&scoped=true&"
import script from "./ModelYM.vue?vue&type=script&lang=js&"
export * from "./ModelYM.vue?vue&type=script&lang=js&"
import style0 from "./ModelYM.vue?vue&type=style&index=0&id=78ea2540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ea2540",
  null
  
)

export default component.exports